module.exports = __webpack_public_path__ + "img/back-img.fd95ce10.png";